import * as React from 'react';
import { mergeDeepRight } from 'ramda';
import { BASE_CFG } from '../../utils/baseChartConfigParts';
import { parseChartFlatConfig } from '../../utils/parseChartFlatConfig';
export var usePrepareChartConfig = function usePrepareChartConfig(ctx, options) {
  return React.useMemo(function () {
    if (!ctx) {
      return null;
    }
    var datasetCfgCreators = options.datasetCfgCreators,
      directChartCfg = options.directChartCfg,
      chartCfgParams = options.chartCfgParams;
    var datasets = datasetCfgCreators.map(function (cfgCreator) {
      return cfgCreator(ctx, options);
    });
    var resultConfig = mergeDeepRight(BASE_CFG, {
      data: {
        datasets: datasets
      }
    });
    resultConfig = mergeDeepRight(resultConfig, parseChartFlatConfig(chartCfgParams));
    if (directChartCfg) {
      resultConfig = mergeDeepRight(resultConfig, directChartCfg);
    }
    return resultConfig;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx, options.chartCfgParams, options.directChartCfg, options.datasetCfgCreators]);
};